import { render, staticRenderFns } from "./UploadsPane.vue?vue&type=template&id=2f2ec431&scoped=true&"
import script from "./UploadsPane.vue?vue&type=script&lang=js&"
export * from "./UploadsPane.vue?vue&type=script&lang=js&"
import style0 from "./UploadsPane.vue?vue&type=style&index=0&id=2f2ec431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ec431",
  null
  
)

export default component.exports